const pointData = {
	minimumPercentage: 10,
	penaltyPercentage: 10
}

module.exports = {pointData};